import { render, staticRenderFns } from "./Resign.vue?vue&type=template&id=3b0d4924&"
import script from "./Resign.vue?vue&type=script&lang=js&"
export * from "./Resign.vue?vue&type=script&lang=js&"
import style0 from "./Resign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports